import { MEDIA_CDN_BASE } from '@/utils/media'

export const getGameThumbnailUrl = ({ platform, gameId, thumbnailSize = 'default' } = {}) => {
    if (!platform || !gameId) return null

    return `${MEDIA_CDN_BASE}/${platform}/games/thumbnails/${thumbnailSize}/${gameId}`
}
